<template>
	<!-- 雷达图  折线-->
	<!-- 矩阵打分 -->
	<div class="matrixScoreChart">
		<div class="title_box">
			<span class="title_box_span" >
				<span class="textlong" :title="CrossTabs.name">
					<span >{{ CrossTabs.sheet }}:</span>
						{{ htmlToString(CrossTabs.name) }}
				</span>
			</span>
			<span class="el-dropdown_button">
				<el-button plain style="margin-top: 10px; margin-right: 10px" @click="exportExcl(CrossTabs.id)">{{$t('DataRecycling.Export')}}</el-button>
				
				<el-select :popper-append-to-body="false" v-model="CrossTabs.chartType" :key="CrossTabs.id" :placeholder="$t('DataRecycling.PleaseSelect')" @change="selection">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</span>
		</div>
		<div class="echart" ref="echart_div"></div>
		<div class="">
			<table border="1">
				<tr v-for="(item1, index1) in CrossTabs.dataArrayList" :key="index1" class="table_tr">
					<td v-for="(item2, index2) in item1" :key="index2" class="table_tr">{{ item2 }}</td>
				</tr>
				<tr>
					<td colspan="100">{{$t('DataRecycling.NumberOfRespondents')}} : {{ CrossTabs.answerNumber }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts';
export default {
	props: {
		CrossTabs: {
			type: Object //可指定接收类型，如:Array.
		},
		CrossTabsindex: {}
	},
	data() {
		return {
			wid:0,
			seriesData: [],
			legendData: [], //矩阵的说明
			cumulateSeries: [], //矩阵数据
			options: [
				{
					value: '8',
					label: this.$t('DataRecycling.RadarChart')
				},
				{
					value: '5',
					label: this.$t('DataRecycling.FoldLine')
				}
			]
		};
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || this.$route.query.wid || 0;
		this.loadData();
	},
	methods: {
		exportExcl(qid) {
			console.log('CrossTabs', this.CrossTabs);
			var id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportChoice}?id=${id}&state=0&Authorization=Bearer${window.localStorage.getItem('token')}&qid=${qid}&isbank=${that.CrossTabs.isbank}`,
				method: 'Get',
			 data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},		
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		htmlToString(htmlStr){
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g,'')
		},
		selection(val) {
			this.barData = [];
			this.barName = [];
			this.seriesData= [];
			this.legendData= []; //矩阵的说明
			this.cumulateSeries=[];//矩阵数据
			if (val == 8) {
				this.radar();
			}
			if (val == 5) {
				this.matrixBroken();
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setStatisticalStyle}`,
				method: 'POST',
				data: {
					id: that.CrossTabs.id,
					chartType: val,
					isBank: that.CrossTabs.isbank
				},
				cb(res) {
					if (res.code == 0) {
					}
				}
			};
			this.$util.request(params);
		},
		// 雷达图
		radar() {
			let targetArr = [];
			this.CrossTabs.dataArrayList.forEach((val, index) => {
				val.forEach((v, i) => {
					if (targetArr[i]) {
						targetArr[i].push(v);
					} else {
						targetArr[i] = [v];
					}
				});
			});
			console.log(targetArr);
			for (let i = 1; i < targetArr.length; i++) {
				let temporary = {};
				temporary.value = [];
				temporary.name = '';
				for (let l = 1; l < targetArr[i].length; l++) {
					temporary.value.push(targetArr[i][l]);
					let temporaryName = '';
					temporaryName = targetArr[i][0];
					if (!temporaryName) return '';
					if (temporaryName.length > 15) {
						temporaryName = temporaryName.slice(0, 15) + '...';
					}
					temporary.name = temporaryName;
				}
				this.seriesData.push(temporary);
				this.legendData.push(temporary.name);
			}
			let indicator = this.CrossTabs.dataArrayList;
			let temporaryIndicator = [];
			for (let k = 1; k < indicator.length; k++) {
				let temporary = {};
				let temporaryindicator = '';
				temporaryindicator = indicator[k][0];
				if (!temporaryindicator) return '';
				if (temporaryindicator.length > 10) {
					temporaryindicator = temporaryindicator.slice(0, 10) + '...';
				}
				temporary.name = temporaryindicator;
				temporaryIndicator.push(temporary);
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				title: {
					text: `${this.$t('DataRecycling.NumberOfRespondents')} : ${this.CrossTabs.answerNumber} `
				},
				tooltip: {},
				legend: {
					orient: 'vertical',
					x: 'left', //可设定图例在左、右、居中
					y: 'center', //可设定图例在上、下、居中
					padding: [0, 0, 0, 0],
					data: this.legendData
				},
				radar: {
					// shape: 'circle',
					name: {
						textStyle: {
							color: '#fff',
							backgroundColor: '#999',
							borderRadius: 3,
							padding: [3, 5]
						}
					},
					indicator: temporaryIndicator
				},
				series: [
					{
						name: '',
						type: 'radar',
						// areaStyle: {normal: {}},
						data: this.seriesData
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 堆叠折线图
		matrixBroken() {
			let targetArr = [];
			this.CrossTabs.dataArrayList.forEach((val, index) => {
				val.forEach((v, i) => {
					if (targetArr[i]) {
						targetArr[i].push(v);
					} else {
						targetArr[i] = [v];
					}
				});
			});
			
			for (let i = 1; i < targetArr.length; i++) {
				let seriesList = {}; //系列数据
				seriesList.name = '';
				seriesList.type = 'line';
				seriesList.stack = 'Total';
				seriesList.data = []; //x轴数据
				for (let l = 1; l < targetArr[i].length; l++) {
					let temporaryName = '';
					temporaryName = this.htmlToString(targetArr[i][0]);
					if (!temporaryName) return '';
					if (temporaryName.length > 10) {
						temporaryName = temporaryName.slice(0, 10) + '...';
					}
					seriesList.name = temporaryName;
					seriesList.data.push(Number(targetArr[i][l]));
				}
				this.cumulateSeries.push(seriesList);
			}
			
			let indicator = this.CrossTabs.dataArrayList;
			let temporaryIndicator = [];
			for (let k = 1; k < indicator.length; k++) {
				console.log(indicator[k][0]);
				let temporary = '';
				temporary = this.htmlToString(indicator[k][0]);
				if (!temporary) return '';
				if (temporary.length > 10) {
					temporary = temporary.slice(0, 10) + '...';
				}
				temporaryIndicator.push(temporary);
			}
			let temporaryIndicatorX = [];
			for (let k = 1; k < indicator[0].length; k++) {
				console.log(indicator[0][k]);
				let temporary = '';
				temporary = indicator[0][k];
				if (!temporary) return '';
				if (temporary.length > 10) {
					temporary = temporary.slice(0, 10) + '...';
				}
				temporaryIndicatorX.push(temporary);
			}
			
			console.log('111111111', temporaryIndicator);
			console.log('111111111', temporaryIndicatorX);
			console.log('111111111', this.cumulateSeries);
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				title: {
					text: `${this.$t('DataRecycling.NumberOfRespondents')} : ${this.CrossTabs.answerNumber} `
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: temporaryIndicatorX
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: temporaryIndicator
				},
				yAxis: {
					type: 'value'
				},
				series: this.cumulateSeries
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		loadData() {
			this.selection(this.CrossTabs.chartType||'8');
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.matrixScoreChart {
	.title_box {
		width: 100%;
		height: 56px;
		line-height: 56px;
		background: #f9fcff;
		.title_box_span {
			margin-left: 25px;
			font-size: 14px;
			color: #000;
			font-family: Microsoft YaHei;
		}
		.el-dropdown_button {
			float: right;
			margin-right: 20px;
		}
	}
	.echart {
		width: 90%;
		height: 400px;
		margin: 20px auto;
	}
	table {
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;
	}
	
	table tr td {
		padding: 8px 0 8px 10px;
	}
}
</style>
